import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useIsUserAuthenticatedQuery, useRequestNewMultiFactorSecurityTokenMutation, } from "generated/generated-models";
import { Button, FormControl, InputLabel, OutlinedInput, FilledInput, } from "@mui/material";
const RequestMultiFactorTokenComponent = ({ showRequestNewToken = true, errorMessage, getToken, requestMfaOnDisplay = false, visible = true, isUsingGoogleAuth = false, }) => {
    const initialSeconds = 60;
    const [requestToken] = useRequestNewMultiFactorSecurityTokenMutation();
    const [seconds, setSeconds] = useState(0);
    const [alreadyRequestedMfa, setAlreadyRequestedMfa] = useState(false);
    const { data: userSessionData, error: userSessionError, loading: userSessionLoading, } = useIsUserAuthenticatedQuery({
        notifyOnNetworkStatusChange: true,
        errorPolicy: "all",
    });
    const loggedIn = userSessionData && !userSessionError && !userSessionLoading;
    const AuthLabel = isUsingGoogleAuth
        ? "Authorisation Code"
        : "Security Token";
    useEffect(() => {
        if (requestMfaOnDisplay && visible && !alreadyRequestedMfa) {
            setAlreadyRequestedMfa(true);
            setSeconds(initialSeconds);
            requestToken({ variables: { input: {} } });
        }
    }, [requestMfaOnDisplay, visible, alreadyRequestedMfa, requestToken]);
    useEffect(() => {
        let interval = undefined;
        if (seconds > 0) {
            interval = setInterval(() => {
                setSeconds((seconds) => seconds - 1);
            }, 1000);
        }
        else if (seconds === 0) {
            clearInterval(interval);
        }
        return () => {
            if (interval != null) {
                clearInterval(interval);
            }
        };
    }, [seconds]);
    const handleOnChange = (e) => {
        e.stopPropagation();
        if (getToken != null) {
            getToken(e.target.value);
        }
    };
    const RequestTokenButton = () => {
        if (isUsingGoogleAuth) {
            return null;
        }
        const handleClick = () => {
            requestToken({ variables: { input: {} } });
            setSeconds(60);
        };
        if (seconds <= 0) {
            return (_jsx("div", { className: "request-token", children: _jsx(Button, { variant: "text", onClick: handleClick, id: "getNewTokenButton", children: "Get New Token" }) }));
        }
        else {
            return (_jsx("div", { className: "request-token", children: _jsxs("p", { className: "text-muted", children: ["You may request a new token in:", " ", seconds.toString().padStart(2, "0"), " secs."] }) }));
        }
    };
    if (!visible) {
        return null;
    }
    return (_jsx(_Fragment, { children: loggedIn ? (_jsxs("div", { className: "request-token-container", children: [_jsxs(FormControl, { fullWidth: true, variant: "outlined", children: [_jsx(InputLabel, { htmlFor: "Token", children: AuthLabel }), _jsx(OutlinedInput, { id: "Token", type: "text", name: "Token", onChange: handleOnChange, label: AuthLabel })] }), _jsx("div", { className: "invalid-feedback form-error-message d-block", children: errorMessage }), showRequestNewToken && _jsx(RequestTokenButton, {})] })) : (_jsxs("div", { className: "request-token-container", children: [_jsxs(FormControl, { fullWidth: true, variant: "filled", children: [_jsx(InputLabel, { htmlFor: "Token", children: AuthLabel }), _jsx(FilledInput, { id: "Token", type: "text", name: "Token", onChange: handleOnChange })] }), _jsx("div", { className: "invalid-feedback form-error-message d-block", children: errorMessage }), showRequestNewToken && _jsx(RequestTokenButton, {})] })) }));
};
export default RequestMultiFactorTokenComponent;
